import { render, staticRenderFns } from "./BaseInputExpirationDate.vue?vue&type=template&id=5231ea0c&"
import script from "./BaseInputExpirationDate.vue?vue&type=script&lang=js&"
export * from "./BaseInputExpirationDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports